import styled from 'styled-components';

export const Container = styled.div`
  .badge-beta {
    right: 4px;
    top: -8px !important;
    background: ${(props) => props.theme.$dark};
  }
`;
